module.exports = __webpack_public_path__ + "static/img/pc-web-img-01@w.0aca4f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/pc-web-img-01@w.png
// module id = uv8t
// module chunks = 0